<template>
  <div v-if="event !== undefined">
    <template>
      <div
        class="mx-auto"
        v-on:click="handleContentClick($event)"
      >
        <div class="desktop-container">
          <FavouritesButton
            :item="event"
          />

          <img v-if="event._attachments" class="headline__img " :src="'data:' + event._attachments.image.content_type + ';base64,' + event._attachments.image.data" alt="" />
          
          <v-card-title class="pt-8">
            <h1 class="display-1 headline">{{event.name}}</h1>
          </v-card-title>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="pb-1">
                {{hubbdata.catagories.about}}
              </v-list-item-subtitle>

              <span v-html="event.description"></span>
            </v-list-item-content>
          </v-list-item>

          <v-list class="event-list" two-line>
            <v-list-item class="event-list__item" v-if="event.descriptive_date !== null">
              <v-list-item-icon>
                <v-icon color="icons">mdi-calendar</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.event.labels.date}}</v-list-item-subtitle>
                <v-list-item-title>{{ event.next_occuring_date | formatDate  }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="event-list__item" v-if="event.repeat_dates && event.event_repeats_description">
              <v-list-item-icon>
                <v-icon color="icons">mdi-repeat</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle> {{hubbdata.event.labels.recurring}}</v-list-item-subtitle>
                <v-list-item-subtitle> {{hubbdata.event.labels.next}} </v-list-item-subtitle>
                <v-list-item-title class="upcoming-events"> {{upcomingEvents}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="event-list__item" v-if="event.descriptive_time !== null">
              <v-list-item-icon>
                <v-icon color="icons">mdi-clock-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.event.labels.time}}</v-list-item-subtitle>
                <v-list-item-title>{{ event.descriptive_time }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="event.website_address !== null && event.website_address !== ''">
              <v-list-item-icon>
                <v-icon color="icons">mdi-earth</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.catagories.website}}</v-list-item-subtitle>
                <v-list-item-title v-if="linkSet(event.website_address)"><a :href="event.website_address">{{event.website_address}}</a></v-list-item-title>
                <v-list-item-title v-else><a :href="'http://' + event.website_address">{{event.website_address}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="event-list__item" v-if="event.address_1 !== null && event.address_1 !== ''">
              <v-list-item-icon>
                <v-icon color="icons">mdi-map-marker</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.catagories.address}}</v-list-item-subtitle>
                <v-list-item-title>{{event.address_1}}</v-list-item-title>
                <v-list-item-subtitle><span v-if="event.address_2 !== null && event.address_2 !== ''">{{event.address_2}},</span> {{event.town}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <GmapMap
          v-if="event.lattitude !== null && event.longitude !== null"
          :center="{lat:event.latitude, lng:event.longitude}"
          :zoom="10"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
        >
          <GmapMarker
            ref="marker"
            :position="{ lat: event.latitude, lng: event.longitude }"
          />
        </GmapMap>

        <WasThisUseful
          :type="'event'"
        />
      </div>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful"
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';
import moment from 'moment';

export default {
  components: {
    WasThisUseful,
    FavouritesButton
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
      }
    },
  },
  computed: {
    event() {
      return hubbdata.getters.getEventById(this.$route.params.id)
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
    upcomingEvents() {
      if(this.event.repeat_dates) {
        let index_of_next = this.event.repeat_dates.indexOf(this.event.next_occuring_date);
        let next_events = this.event.repeat_dates.slice(index_of_next).slice(0,3);
        return next_events.map(d => moment(String(d)).format('DD/MM/YYYY')).join(', ')
      } else {
        return null
      }
    },
  },
  methods: {
    linkSet(url) {
      if (url.indexOf("http") > -1){
        return true
      }
      else {
        return false
      }
    },
  },
  mounted: function() {
    if (this.event !== undefined) {
      ga('set', 'title', hubbdata.getters.getEventById(this.$route.params.id).name); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
    }
  },
}
</script>

<style lang="scss" scoped>
.headline {
  word-break: normal;
  margin-right: 60px;

  &__img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
  }
}

.event-list {
  
  &__item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    &:last-child {
      border-bottom: none;
    }
  }
}

a {
  color: $blue;
}

.v-card {
  box-shadow: 0px 0px 0px 0px !important;
}

.upcoming-events {
  overflow: visible;
  white-space: pre-wrap;
}
</style>